import React from 'react';
import { TrendingUp, ShieldAlert, BrainCircuit, BatteryCharging, Apple, Dumbbell } from 'lucide-react';
export function Solution() {
  const benefits = [{
    icon: <TrendingUp className="w-8 h-8 text-orange-500" data-id="element-141" />,
    label: 'Subí de grado real'
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-orange-500" data-id="element-142" />,
    label: 'Evitá lesiones de dedos y hombros'
  }, {
    icon: <BrainCircuit className="w-8 h-8 text-orange-500" data-id="element-143" />,
    label: 'Entrená con criterio, no por costumbre'
  }, {
    icon: <BatteryCharging className="w-8 h-8 text-orange-500" data-id="element-144" />,
    label: 'Recuperación inteligente'
  }, {
    icon: <Apple className="w-8 h-8 text-orange-500" data-id="element-145" />,
    label: 'Nutrición específica'
  }, {
    icon: <Dumbbell className="w-8 h-8 text-orange-500" data-id="element-146" />,
    label: 'Antebrazos que no se queman'
  }];
  return <section className="py-16 md:py-24 px-4 bg-darker border-y border-gray-900" data-id="element-147">
      <div className="max-w-5xl mx-auto" data-id="element-148">
        <h2 className="text-4xl md:text-5xl font-bebas text-center mb-10" data-id="element-149">
          LA SOLUCIÓN PARA EL{' '}
          <span className="text-orange-500" data-id="element-150">ESCALADOR AMATEUR</span>
        </h2>

        <div className="max-w-3xl mx-auto text-lg text-gray-300 mb-16 text-center" data-id="element-151">
          <p data-id="element-152">
            La mayoría se estanca por copiar rutinas avanzadas y acumular fatiga
            invisible. <strong data-id="element-153">Escalada Pro System</strong> te da una progresión
            estructurada para romper plateaus, cuidar dedos y hombros, y escalar
            más fuerte sin quemarte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-154">
          {benefits.map((benefit, idx) => <div key={idx} className="bg-card border border-gray-800 p-6 rounded-xl flex flex-col items-center text-center hover:border-orange-500/50 transition-colors" data-id="element-155">
              <div className="bg-orange-500/10 p-4 rounded-full mb-4" data-id="element-156">
                {benefit.icon}
              </div>
              <h3 className="font-bold text-lg" data-id="element-157">{benefit.label}</h3>
            </div>)}
        </div>
      </div>
    </section>;
}